export const day = {
  mon: {
    full: 'Monday',
    short: 'Mo'
  },

  tue: {
    full: 'Tuesday',
    short: 'Tu'
  },

  wed: {
    full: 'Wednesday',
    short: 'We'
  },

  thu: {
    full: 'Thursday',
    short: 'Th'
  },

  fri: {
    full: 'Friday',
    short: 'Fr'
  },

  sat: {
    full: 'Saturday',
    short: 'Sa'
  },

  sun: {
    full: 'Sunday',
    short: 'Su'
  }
};
